import React from "react";
import upload from "../assests/images/upload.svg";
import runisort from "../assests/images/runisort.svg";
import viewResultIcon from "../assests/images/viewResultIcon.svg";
import { Link } from "react-router-dom";
export default function Action() {
  return (
    <div style={{ padding: "17px 0 0 0" }}>
      <div className="row justify-content-between actions-menu">
        <div className="col-12 col-xl-4">
          <Link
            to="/uploadfile"
            style={{ textDecoration: "none", color: "black" }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                backgroundColor: "#FFE6C9",
              }}
            >
              <img src={upload} alt="" />
              <span className="custom-title">Upload Input Files</span>
            </div>
          </Link>
        </div>
        <div className="col-12 col-xl-4">
          <Link
            to="/runisort"
            style={{ textDecoration: "none", color: "black" }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                backgroundColor: "#DDF0F8",
              }}
            >
              <img src={runisort} alt="" className="" />
              <span className="custom-title">Run iSort&trade;</span>
            </div>
          </Link>
        </div>
        <div className="col-12 col-xl-4">
          <Link
            to="/results"
            style={{ textDecoration: "none", color: "black" }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                backgroundColor: "#FFE1D4",
                borderRadius: "0.5rem",
              }}
            >
              <img src={viewResultIcon} alt="" />
              <span className="custom-title">View Results</span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
